import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { chatbotToken } from "../../Utils/Constant";
import environments from "../../Utils/Environment";

const BOT_TYPES = {
  default: "/hoa_assistant_bot",
  realestate: "/realestate_hoa_assistant_bot",
  market: "/market_insights_hoa_assistant_bot",
  mortgage_solutions: "/mortgage_solutions_hoa_assistant_bot",
  home_insurance: "/home_insurance_hoa_assistant_bot"
};

export const chatbotPostApi = createAsyncThunk(
  "chatbot/chatbotPostApi",
  async ({ question, session_id, community_name, type }, { rejectWithValue }) => {
    try {
      // Create a FormData object and append fields
      const formData = new FormData();
      formData.append("question", question);
      formData.append("session_id", session_id);

      // Append community_name as null if it's null, otherwise append the actual value
      if (community_name === null) {
        formData.append("community_name", null);
      } else if (community_name) {
        formData.append("community_name", community_name);
      }

      const url = BOT_TYPES[type] || BOT_TYPES.default;

      // Make the POST request
      const response = await axios.post(
        `${environments.prod.chatbotUrl}${url}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${chatbotToken}`, // Add the Bearer token here
            "Content-Type": "multipart/form-data", // Set appropriate Content-Type
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);